export class AppConfig {
  public sacServicesUrl: string = process.env.VUE_APP_SAC_SERVICES_URL
}
